import { opportunityFetch } from "./opportunityFetch";

export function createOpportunityFollowOnDeal(payload: { opportunity_id: string }) {
  return opportunityFetch<{
    ok: true;
    deal_id: string;
    original_ops_deal_id: string | null;
    deal_ids_for_serial: string[];
    existing?: boolean;
  }>("/api/opportunity/create-follow-on-deal", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
